
import { defineComponent, ref } from 'vue';
import TelaPadraoCrud from '@/core/components/TelaPadraoCrud.vue';
import { useCrudBase } from '@/core/composables/CrudBase';
import EstoqueModal from '@/views/Cadastros/Estoques/EstoqueModal.vue';
import { ECustomRenderRow } from '@/core/models/AntDesign/IColumn';
import { IOrdenacao } from '@/core/models/Consulta/IOrdenacao';
import { EPermissaoDados } from '@/models/Enumeradores/MeuSistema/Usuarios/EPermissaoDados';
import ServicoEstoque from '@/servicos/Cadastros/Estoques/ServicoEstoque';

export default defineComponent({
  name: 'Estoque',
  components: {
    TelaPadraoCrud,
    EstoqueModal,
  },
  setup() {
    const {
      crudBase, preencherEstrutura, exibirModal, sincronizaTelaCrud,
    } = useCrudBase();
    const servicoEstoque = new ServicoEstoque();

    const refCrud = ref<InstanceType<typeof TelaPadraoCrud>>();

    crudBase.estrutura = preencherEstrutura();
    crudBase.estrutura.titulo = 'Estoques';
    crudBase.estrutura.apresentarEmpresas = true;
    crudBase.estrutura.verificarCadastroCompartilhado = true;
    crudBase.estrutura.botaoPrincipalAcao = 'Novo';
    crudBase.estrutura.mensagemExclusao = 'Você confirma a exclusão do estoque:';
    crudBase.estrutura.colunasGrade = [
      {
        title: 'Código', dataIndex: 'codigo', key: 'CodigoEstoque', position: 0, visible: false, ordering: true,
      },
      {
        title: 'Descrição', dataIndex: 'descricao', key: 'DescricaoEstoque', position: 1, visible: true, ordering: true, fixed: 'left', align: 'left', customRenderRow: ECustomRenderRow.LinkAcao,
      },
      {
        title: 'Sigla', dataIndex: 'sigla', key: 'SiglaEstoque', identificadorConsulta: 'Sigla', position: 2, width: 100, visible: true, ordering: false, align: 'left',
      },
      {
        title: 'Tipo', dataIndex: 'tipoDescricao', key: 'TipoEstoque', position: 3, visible: true, ordering: true, align: 'left',
      },
      {
        title: 'Status', dataIndex: 'ativo', key: 'AtivoEstoque', position: 4, width: 100, visible: true, align: 'left', customRenderRow: ECustomRenderRow.TagAtivo,
      },
      {
        title: 'Ações', key: 'acoes', position: 5, visible: true, fixed: 'right', width: 100, align: 'center', customRenderRow: ECustomRenderRow.IconeAcoes,
      },
    ];
    crudBase.estrutura.ordenacaoPadraoGrade.push({ identificador: 'Codigo', ordem: 'DESC' } as IOrdenacao);

    async function sincronizarRegistro(acao: EPermissaoDados, codigoRegistro: number) {
      if (refCrud.value !== undefined) {
        await refCrud.value.sincronizarRegistro(acao, codigoRegistro);
      }
    }

    return {
      crudBase,
      servicoEstoque,
      refCrud,
      exibirModal,
      sincronizaTelaCrud,
      sincronizarRegistro,
    };
  },
});
